

import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { ICenterParameterFilter } from "../models/filters/centerParameterFilter";
import { ICenterParameterForm } from "../models/forms/centerParameterForm";
import { ICenterParameterPDTO } from "../models/dtos/centerParameterPDTO";

export default class CenterParameterService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/centerParameters";

    protected static override  getUrlFilter<F extends ICenterParameterFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
            if(filter.parameterId != undefined)
                url += `&ParameterId=${filter.parameterId}`;
            if(filter.code1 != undefined)
                url += `&Code1=${filter.code1}`;
            if(filter.code2 != undefined)
                url += `&Code2=${filter.code2}`;
        }
        
        return url;
    }

    public static override toDTO(obj:ICenterParameterForm):ICenterParameterPDTO {
        const dto = super.toDTO(obj) as ICenterParameterPDTO;
        return dto;
    }
}